<template>
  <div class="ant-cascader-select">
    <a-select
      show-search
      ref="selector"
      mode="multiple"
      :maxTagCount="1"
      @focus="openMenu"
      @blur="closeMenu"
      :showArrow="true"
      :allowClear="true"
      style="width: 100%"
      :open="menuVisible"
      :labelInValue="true"
      v-model="optionName"
      :maxTagTextLength="4"
      @deselect="deselect"
      :placeholder="$t('pleaseSelectMajor')"
      :filterOption="filterOption"
      :dropdownMatchSelectWidth="false"
      :optionLabelProp="optionLabelProp"
      dropdownClassName="ant-cascader-select-drop"
    >
      <img v-if="optionName.length > 0" @click="clear" class="clear-icon" slot="clearIcon" :src="require('@/assets/icons/icon_gb.png')" alt="" srcset="">
      <div slot="dropdownRender">
        <!-- cascader-two-leval -->
        <!-- cascader-parent -->
        <a-col>
          <a-list size="small" :data-source="listData" :split="false">
            <a-list-item
              slot="renderItem"
              slot-scope="item, index"
              @click="() => handleClick(item, 0, index)"
              :class="{active: parentActiveIdx === index || getChecked(item, 0) }"
            >
              <a-checkbox :indeterminate="getIndeterminate(item, 0)" :checked="getChecked(item, 0)" @click="handlerChange(item, 0, getChecked(item, 0))"></a-checkbox>
              <span>{{ item.name }}</span>
              <a-icon type="right" />
            </a-list-item>
          </a-list>
        </a-col>
        <!-- cascader-child -->
        <a-col v-if="parentActiveIdx > -1">
          <a-list size="small" :data-source="childList" :split="false">
            <a-list-item :class="{active: childActiveIdx === index || getChecked(item, 1) }" slot="renderItem" slot-scope="item, index" @click="() => handleClick(item, 1, index)">
              <a-checkbox :indeterminate="getIndeterminate(item, 1)" :checked="getChecked(item, 1)" @click="handlerChange(item, 1, getChecked(item, 1))"></a-checkbox>
              <span>{{ item.name }}</span>
              <a-icon type="right" />
            </a-list-item>
          </a-list>
        </a-col>
        <!-- cascader-child -->
        <a-col v-if="childActiveIdx > -1">
          <a-list size="small" :data-source="subList" :split="false">
            <a-list-item :class="{active: subActiveIdx === index || getChecked(item, 2) }" slot="renderItem" slot-scope="item, index" @click="() => handleClick(item, 2, index)">
              <a-checkbox :checked="getChecked(item, 2)" @click="handlerChange(item, 2, getChecked(item, 2))"></a-checkbox>
              <span>{{ item.name }}</span>
            </a-list-item>
          </a-list>
        </a-col>
      </div>
    </a-select>
  </div>
</template>
<script>

export default {
  props: {
    defaultValue: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      curVal: [],
      parentActiveIdx: undefined,
      childActiveIdx: undefined,
      subActiveIdx: undefined,
      addVisible: false,
      newItemName: '',
      confirmLoading: false,
      menuVisible: false,
      isAdding: false // distinguish whether the operation is for adding
    }
  },
  methods: {
    // 清空专业所有数据
    clear() {
      this.curVal = []
      this.$emit('handleCheckboxChange', this.curVal)
    },
    // 单个数据删除
    deselect(el) {
      const list = [...this.curVal]
      list.forEach((item, index) => {
        if (el.label !== item.name || !el.key) return
        if (item.V1 == el.key.V1 && item.V2 == el.key.V2 && item.V3 == el.key.V3) {
          this.curVal.splice(index, 1)
        }
      })
      this.$emit('handleCheckboxChange', this.curVal)
    },
    // 下拉子菜单展开
    handleClick(option, activeIdx, index) {
      switch (activeIdx) {
        case 0 :
          this.childActiveIdx = this.parentActiveIdx === index && this.getChecked(option, activeIdx) ? this.childActiveIdx : undefined
          this.parentActiveIdx = index
          break
        case 1 :
          this.subActiveIdx = this.childActiveIdx === index && this.getChecked(option, activeIdx) ? this.subActiveIdx : undefined
          this.childActiveIdx = index
          break
        case 2 :
          this.subActiveIdx = this.getChecked(option, activeIdx) ? index : undefined
      }
      this.$refs.selector.focus()
    },
    delRedata(option, activeIdx) {
      const list = [...this.curVal]
      if (activeIdx === 0) {
        // console.log('*****  0 *******', this.curVal)
        list.forEach((item, itemdex) => {
          if (item.V1 == option.checkedId.V1) {
            // console.log(' ----- 0 item', item)
            this.curVal.splice(this.curVal.indexOf(item), 1)
          }
        })
      }
      if (activeIdx === 1) {
        list.forEach((item, itemdex) => {
          // 当item(已存选中)为第一层数据时
          if (item.V1 && !item.V2 && !item.V3) {
            if (item.V1 == option.checkedId.V1) {
              this.curVal.splice(this.curVal.indexOf(item), 1)
              // 将当前层级下除当前选中的数据，全部push
              this.childList.forEach(child => {
                console.log(option.checkedId.V2 != child.checkedId.V2, option.checkedId.V2, child.checkedId.V2)
                if (option.checkedId.V2 != child.checkedId.V2) {
                  const checkedData = {
                    name: child.name,
                    V1: child.checkedId.V1 ? Number(child.checkedId.V1) : undefined,
                    V2: child.checkedId.V2 ? Number(child.checkedId.V2) : undefined,
                    V3: child.checkedId.V3 ? Number(child.checkedId.V3) : undefined
                  }
                  this.curVal.push(checkedData)
                }
              })
            }
          }
          // 当item(已存选中)为第二层数据时
          if (item.V1 && item.V2 && !item.V3) {
            if (item.V1 == option.checkedId.V1 && item.V2 == option.checkedId.V2) {
              this.curVal.splice(this.curVal.indexOf(item), 1)
            }
          }
          // 当item(已存选中)为第三层数据时
          if (item.V1 && item.V2 && item.V3) {
            if (item.V1 == option.checkedId.V1 && item.V2 == option.checkedId.V2) {
              this.curVal.splice(this.curVal.indexOf(item), 1)
            }
          }
        })
      }
      if (activeIdx === 2) {
        list.forEach((item, itemdex) => {
          // 当item(已存选中)为第一层数据时
          if (item.V1 && !item.V2 && !item.V3) {
            if (item.V1 == option.checkedId.V1) {
              this.curVal.splice(this.curVal.indexOf(item), 1)
              // 将当前层级下除当前选中的数据，全部push
              this.childList.forEach(child => {
                if (option.checkedId.V2 != child.checkedId.V2) {
                  const checkedData = {
                    name: child.name,
                    V1: child.checkedId.V1 ? Number(child.checkedId.V1) : undefined,
                    V2: child.checkedId.V2 ? Number(child.checkedId.V2) : undefined,
                    V3: child.checkedId.V3 ? Number(child.checkedId.V3) : undefined
                  }
                  this.curVal.push(checkedData)
                } else {
                  child.sub.forEach(sub => {
                    if (option.checkedId.V3 !== sub.checkedId.V3) {
                      const checkedData = {
                        name: sub.name,
                        V1: sub.checkedId.V1 ? Number(sub.checkedId.V1) : undefined,
                        V2: sub.checkedId.V2 ? Number(sub.checkedId.V2) : undefined,
                        V3: sub.checkedId.V3 ? Number(sub.checkedId.V3) : undefined
                      }
                      this.curVal.push(checkedData)
                    }
                  })
                }
              })
            }
          }
          // 当item(已存选中)为第二层数据时
          if (item.V1 && item.V2 && !item.V3) {
            if (item.V1 == option.checkedId.V1 && item.V2 == option.checkedId.V2) {
              this.curVal.splice(this.curVal.indexOf(item), 1)
              this.childList.forEach(child => {
                if (child.checkedId.V2 != option.checkedId.V2) return
                child.sub.forEach(sub => {
                  if (sub.checkedId.V3 != option.checkedId.V3) {
                      const checkedData = {
                        name: sub.name,
                        V1: sub.checkedId.V1 ? Number(sub.checkedId.V1) : undefined,
                        V2: sub.checkedId.V2 ? Number(sub.checkedId.V2) : undefined,
                        V3: sub.checkedId.V3 ? Number(sub.checkedId.V3) : undefined
                      }
                      this.curVal.push(checkedData)
                  }
                })
              })
            }
          }
          // 当item(已存选中)为第三层数据时
          if (item.V1 && item.V2 && item.V3) {
            if (item.V1 == option.checkedId.V1 && item.V2 == option.checkedId.V2 && item.V3 == option.checkedId.V3) {
              this.curVal.splice(this.curVal.indexOf(item), 1)
            }
          }
        })
      }
    },
    // 新选项数据加入后
    optionAllChecked(obj, activeIdx) {
      let allChecked = false
      // 当前选中数据为第二层
      if (activeIdx === 1) {
          const childLength = this.childList.length
          let curValLength = 0
          this.curVal.forEach(it => {
            if (it.V1 && it.V2 && !it.V3 && it.V1 == obj.V1) {
              curValLength += 1
            }
          })
          allChecked = childLength === curValLength + 1
      } else { // 当前选中数据为第三层
        const subLength = this.subList.length
        let curValLength = 0
        this.curVal.forEach(it => {
          if (it.V1 && it.V2 && it.V3 && it.V1 == obj.V1 && it.V2 == obj.V2) {
            curValLength += 1
          }
        })
        allChecked = subLength === curValLength + 1
      }
      return allChecked
    },
    // 选中数据
    handlerChange(option, activeIdx, checked) {
      let index = -1
      if (this.curVal.length > 0) {
        index = this.curVal.findIndex(item => {
          // 当item(已存选中)为第1层数据时
          if (item.V1 && !item.V2 && !item.V3) {
            return item.V1 == option.checkedId.V1
          }
          // 当item(已存选中)为第2层数据时
          if (item.V1 && item.V2 && !item.V3) {
            if (activeIdx === 0) {
              return item.V1 == option.checkedId.V1
            } else {
              return item.V1 == option.checkedId.V1 && item.V2 == option.checkedId.V2
            }
          }
          // 当item(已存选中)为第3层数据时
          if (item.V1 && item.V2 && item.V3) {
            if (activeIdx === 0) {
              return item.V1 == option.checkedId.V1
            } else if (activeIdx === 1) {
              return item.V1 == option.checkedId.V1 && item.V2 == option.checkedId.V2
            } else if (activeIdx === 2) {
              return item.V1 == option.checkedId.V1 && item.V2 == option.checkedId.V2 && item.V3 == option.checkedId.V3
            }
          }
        })
      }
      console.log(index, option)
      // console.log('&&&&&&  change   &&&&&&', index, activeIdx, option.checkedId, this.curVal)
      if (index > -1) {
        this.delRedata(option, activeIdx)
      } else {
        const obj = {
          name: option.name,
          V1: option.checkedId.V1 ? Number(option.checkedId.V1) : undefined,
          V2: option.checkedId.V2 ? Number(option.checkedId.V2) : undefined,
          V3: option.checkedId.V3 ? Number(option.checkedId.V3) : undefined
        }
        if (activeIdx > 0) {
          const allChecked = this.optionAllChecked(obj, activeIdx)
          console.log('fvgbhnj', allChecked, this.curVal)
          if (allChecked) { // 当前子选项全部选中
            if (activeIdx === 1) {
              const list = [...this.curVal]
              list.forEach((item, index) => {
                if (item.V1 == obj.V1) {
                  this.curVal.splice(this.curVal.indexOf(item), 1)
                }
              })
              obj.V2 = undefined
              obj.name = this.listData.find(item => { return item.id == obj.V1 }).name
              this.curVal.push(obj)
            } else {
              const objj = Object.assign(obj, {
                V3: undefined
              })
              const subAllChecked = this.optionAllChecked(objj, 1)
              if (subAllChecked) {
                const list = [...this.curVal]
                list.forEach((item, index) => {
                  if (item.V1 == objj.V1) {
                    this.curVal.splice(this.curVal.indexOf(item), 1)
                  }
                })
                objj.V2 = undefined
                objj.name = this.listData.find(item => { return item.id == objj.V1 }).name
                this.curVal.push(objj)
              } else {
                const list = [...this.curVal]
                list.forEach((item, index) => {
                  if (item.V1 == objj.V1 && item.V2 == objj.V2) {
                    this.curVal.splice(this.curVal.indexOf(item), 1)
                  }
                })
                objj.name = this.childList.find(item => { return item.id == objj.V2 }).name
                this.curVal.push(objj)
              }
            }
          } else {
            this.curVal.push(obj)
          }
        } else {
          this.curVal.push(obj)
        }
      }
      this.$emit('handleCheckboxChange', this.curVal)
    },
    getChecked (option, activeIdx) {
      const index = this.curVal.findIndex(item => {
        // 当item(已存选中)为第1层数据时
        if (item.V1 && !item.V2 && !item.V3) {
          return item.V1 === option.checkedId.V1
        }
        // 当item(已存选中)为第2层数据时
        if (item.V1 && item.V2 && !item.V3) {
          if (activeIdx === 0) {
            return item.V1 === option.checkedId.V1
          } else {
            return item.V1 === option.checkedId.V1 && item.V2 === option.checkedId.V2
          }
        }
        // 当item(已存选中)为第3层数据时
        if (item.V1 && item.V2 && item.V3) {
          if (activeIdx === 0) {
            return item.V1 === option.checkedId.V1
          } else if (activeIdx === 1) {
            return item.V1 === option.checkedId.V1 && item.V2 === option.checkedId.V2
          } else if (activeIdx === 2) {
            return item.V1 === option.checkedId.V1 && item.V2 === option.checkedId.V2 && item.V3 === option.checkedId.V3
          }
        }
      })
      return index > -1
    },
    getIndeterminate(option, activeIdx) {
      const index = this.curVal.findIndex(item => {
        // 当item(已存选中)为第2层数据时
        if (item.V1 && item.V2 && !item.V3) {
          if (activeIdx === 0) {
            return item.V1 === option.checkedId.V1
          }
        }
        // 当item(已存选中)为第3层数据时
        if (item.V1 && item.V2 && item.V3) {
          if (activeIdx === 0) {
            return item.V1 === option.checkedId.V1
          } else if (activeIdx === 1) {
            return item.V1 === option.checkedId.V1 && item.V2 === option.checkedId.V2
          } else if (activeIdx === 2) {
            return item.V1 === option.checkedId.V1 && item.V2 === option.checkedId.V2 && item.V3 === option.checkedId.V3
          }
        }
      })
      return index > -1
    },
    handleInputConfirm () {
      this.handleOk()
    },
    openMenu () {
      this.menuVisible = true
    },
    closeMenu () {
      this.menuVisible = false
      this.parentActiveIdx = undefined
      this.childActiveIdx = undefined
      this.subActiveIdx = undefined
    }
  },
  computed: {
    listData() {
      const treeList = JSON.parse(localStorage.treeList)
      return treeList
    },
    childList () {
      return this.listData && this.listData.length > 0 ? this.listData[this.parentActiveIdx]['children'] : []
    },
    subList() {
      return this.childList && this.childList.length > 0 ? this.childList[this.childActiveIdx]['sub'] : []
    },
    curLang () {
      return this.$i18n && this.$i18n.locale || 'zh-CN'
    },
    isZh () {
      return this.curLang === 'zh-CN'
    },
    optionName () {
      const list = []
      this.curVal.forEach(item => {
        const obj = {
          label: item.name,
          key: {
            V1: item.V1,
            V2: item.V2,
            V3: item.V3
          }
        }
        list.push(obj)
      })
      return list
    },
    optionValue () {
      return this.optionFilterProp || 'value'
    }
  },
  mounted() {
  },
  watch: {
    defaultValue: {
      handler(el) {
        console.log('init', el, this.listData)
        el.forEach(item => {
          this.listData.forEach(phase => {
            if (Number(item.V1) > 0 && Number(item.V2) < 1 && Number(item.V3) < 1) {
              if (phase.checkedId.V1 != item.V1) return
              const obj = {
                V1: phase.checkedId.V1 ? Number(phase.checkedId.V1) : undefined,
                V2: phase.checkedId.V2 ? Number(phase.checkedId.V2) : undefined,
                V3: phase.checkedId.V3 ? Number(phase.checkedId.V3) : undefined,
                name: phase.name
              }
              this.curVal.push(obj)
            }
            if (Number(item.V1) > 0 && Number(item.V2) > 0 && Number(item.V3) < 1) {
              if (phase.checkedId.V1 != item.V1) return
              if (phase.children && phase.children.length === 0) return
              phase.children.forEach(child => {
                if (item.V2 != child.checkedId.V2) return
                const objj = {
                  V1: child.checkedId.V1 ? Number(child.checkedId.V1) : undefined,
                  V2: child.checkedId.V2 ? Number(child.checkedId.V2) : undefined,
                  V3: child.checkedId.V3 ? Number(child.checkedId.V3) : undefined,
                  name: child.name
                }
                this.curVal.push(objj)
              })
            }
            if (Number(item.V1) > 0 && Number(item.V2) > 0 && Number(item.V3) > 0) {
              if (phase.checkedId.V1 == item.V1) {
                if (phase.children && phase.children.length === 0) return
                phase.children.forEach(child => {
                  if (item.V2 != child.checkedId.V2) return
                  child.sub.forEach(sub => {
                    if (item.V3 != sub.checkedId.V3) return
                    const objjj = {
                      V1: sub.checkedId.V1 ? Number(sub.checkedId.V1) : undefined,
                      V2: sub.checkedId.V2 ? Number(sub.checkedId.V2) : undefined,
                      V3: sub.checkedId.V3 ? Number(sub.checkedId.V3) : undefined,
                      name: sub.name
                    }
                    this.curVal.push(objjj)
                  })
                })
              }
            }
          })
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.ant-select{
  height: 35px !important;
  max-height: 35px !important;
}
/deep/.ant-select-selection__clear{
  img{
    width: 14px;
    height: 14px;
  }
}
/deep/.ant-cascader-select,
/deep/.ant-select.ant-select-enabled.ant-select-allow-clear,
/deep/.ant-select-selection--multiple{
  // width: 200px;
  height: 35px;
  max-height: 35px;
  min-height: auto !important;
  border-radius: 20px;
  .ant-select-selection__rendered{
    height: 35px;
    color: #000;
  }
}
/deep/.ant-select.ant-select-open.ant-select-focused.ant-select-enabled.ant-select-show-arrow{
  .ant-select-arrow .ant-select-arrow-icon{
    color: #FF6D00 !important;
  }
}
/deep/.ant-select-selection--multiple .ant-select-arrow{
  top: 17.5px;
}
.ant-cascader-select-drop {
  display: flex;
  z-index: 100;
}
.ant-cascader-select-drop .ant-list-something-after-last-item .ant-spin-container > .ant-list-items > .ant-list-item:last-child {
  border-bottom: none;
}
.ant-cascader-select-drop .ant-select-dropdown-content {
  width: 100%;
  display:flex;
}
.ant-cascader-select-drop .ant-select-dropdown-content .ant-col:first-child {
  min-width: 120px;
}
.ant-cascader-select-drop .ant-select-dropdown-content .ant-col + .ant-col {
  border-left: 1px solid #e8e8e8;
  flex: 1;
  width: 220px;
  height: 300px;
  overflow-y: scroll;
}
.ant-cascader-select-drop .ant-select-dropdown-content .ant-col + .ant-col::-webkit-scrollbar{
  // display: none;
  width: 5px;
}
.ant-cascader-select-drop .ant-select-dropdown-content .ant-col:last-child li{
  justify-content: flex-start;
}
.ant-cascader-select-drop .ant-select-dropdown-content .ant-col li .ant-checkbox-wrapper{
  margin-right: 12px;
}
.ant-cascader-select-drop .ant-list-items .ant-list-item {
  padding-left: 12px;
  padding-right: 12px;
  cursor: pointer;
  justify-content: flex-start;
  position: relative;
  .anticon.anticon-right{
    right: 12px;
    position: absolute;
  }
}
.ant-cascader-select-drop .ant-list-items .ant-list-item > span {
  white-space: nowrap;
}
.ant-cascader-select-drop .ant-list-footer .ant-tag {
  margin-left: 12px;
  cursor: pointer;
}
.ant-cascader-select-drop .ant-list-footer .ant-input {
  margin-left: 12px;
  width: calc(100% - 24px)!important;
}
.ant-cascader-select-drop .ant-list-footer .ant-input + .ant-input-suffix{
  margin-right: 6px;
}
.ant-cascader-select-drop .ant-list-footer .ant-input + .ant-input-suffix i{
  color: #FF6D00;
}
.ant-cascader-select-drop .ant-list-items .ant-list-item:hover, .ant-cascader-select-drop .ant-list-items .ant-list-item.active {
  color: #FF6D00;
}

.ant-cascader-select-drop .ant-list-items .ant-list-item:hover i, .ant-cascader-select-drop .ant-list-items .ant-list-item.active i{
  color: #FF6D00;
}
.ant-cascader-select-drop .ant-list-items .ant-list-item i{
  font-size: 10px;
  color: #7d8292;
  margin-left: 6px;
}
</style>
